import { call, takeLatest, takeEvery } from 'redux-saga/effects';
import {
  SIGN_IN,
  RESEND_PASSWORD,
  CHECK_REGISTRATION,
  SEND_FINISH_REGISTRATION_EMAIL,
} from '../redux/action/types';
import { loginApi, areaApi } from '../utils/api';

function* signIn(action) {
  try {
    let response = yield call(() => loginApi.signIn(action.data.data));
    if (response && response.status === 200) {
      action.data.onSuccess(response.data);
    }
  } catch (err) {
    if (err && [400, 401, 403].includes(err.status)) {
      action.data.onBadCredentials();
    } else {
      console.log(err);
    }
  }
}

function* resendPassword(action) {
  try {
    let response = yield call(() => areaApi.resendPassword(action.data.data));
    if (response && response.status === 200) {
      action.data.onSuccess(response.data);
    }
  } catch (err) {
    if ((err && err.status === 403) || (err && err.status === 400)) {
      action.data.onBadId();
    } else {
      console.log(err);
    }
  }
}

function* checkRegistration(action) {
  try {
    const response = yield call(() => areaApi.checkRegistration(action.data.id));
    if (response && response.status === 200) {
      action.data.onSuccess(response.data);
    }
  } catch (err) {
    action.data.onError && action.data.onError(err);
    console.log(err);
  }
}

function* sendFinishRegistrationEmail(action) {
  try {
    const response = yield call(() => areaApi.sendFinishRegistrationEmail(action.data));
    if (response && response.status === 200) {
      action.data.onSuccess(response.data);
    }
  } catch (err) {
    action.data.onError && action.data.onError();
    console.log(err);
  }
}

function* authSaga() {
  yield takeLatest(SIGN_IN, signIn);
  yield takeLatest(RESEND_PASSWORD, resendPassword);
  yield takeEvery(CHECK_REGISTRATION, checkRegistration);
  yield takeEvery(SEND_FINISH_REGISTRATION_EMAIL, sendFinishRegistrationEmail);
}

export default authSaga;
